import { Path } from "react-hook-form";
import { TbCancel, TbPlaneArrival, TbPlaneDeparture } from "react-icons/tb";

import { CreatePassengerForm } from "@/pages/Plannn/components/CreateUser/CreateCustomPassengerDialog";
import { PlanFilterStatuses } from "@/stores/use-plan-table";
import { CommonStatusItem } from "@/types/global";

// Brightness1RoundedIcon
import { softColors } from "./colors";

export type OperationStatusItem = CommonStatusItem & {
    cond: (cancelled: boolean, isFlightArrival: boolean, typeValid: boolean) => boolean;
    value: PlanFilterStatuses;
    label: string;
    color: "success" | "primary" | "error";
    labelDesc: string;
    formPath: Path<CreatePassengerForm>;
};
export const operationStatuses: OperationStatusItem[] = [
    {
        cond: (cancelled, isFlightArrival, typeValid) => typeValid && !cancelled && !!isFlightArrival,
        component: () => TbPlaneArrival,
        ...softColors.indigo,
        tooltip: {
            title: "Geliş Yolcusu",
            description: "Yolcu yurt dışından kliniğe gelecektir.",
        },
        value: PlanFilterStatuses.ARRIVAL,
        label: "Geliş",
        labelDesc: "Geliş bilgisi ekleyin",
        color: "primary",
        formPath: "step2.arrival.add",
    },
    {
        cond: (cancelled, isFlightArrival, typeValid) => typeValid && !cancelled && !isFlightArrival,
        component: () => TbPlaneDeparture,
        ...softColors.green,
        tooltip: {
            title: "Gidiş Yolcusu",
            description: "Yolcu havalimanlarından birine gidecektir. ",
        },
        value: PlanFilterStatuses.DEPARTURE,
        label: "Gidiş",
        labelDesc: "Gidiş bilgisi ekleyin",
        color: "success",
        formPath: "step2.departure.add",
    },
    {
        cond: (cancelled) => !!cancelled,
        component: () => TbCancel,
        ...softColors.red,
        tooltip: {
            title: "İptal",
            description: "Yolcu transferi iptal edilmiştir. ",
        },
        value: PlanFilterStatuses.CANCELLED,
        label: "İptal",
        labelDesc: "İptal bilgisi ekleyin",
        color: "error",
        formPath: "step2.arrival.add",
    },
];
